import { BaseText, Button, Divider } from '@croquiscom/pds';
import styled from '@emotion/styled';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Email, MfaMethod, Name, Tel, Password, NewPassword, IsChangePassword, ConfirmNewPassword } from './Input';
import { UpdateUserFormValues } from './UpdateUserFormProvider';
import { flex, mv, padding } from '@/common/styles';
import { Flex } from '@/components/common';

interface Props {
  requirePasswordChange?: boolean;
  loading?: boolean;
  disabled?: boolean;
  onSubmit?: (values: UpdateUserFormValues) => void;
  onCancel?: () => void;
}

export const Form: FC<Props> = ({ requirePasswordChange, loading, disabled, onSubmit, onCancel }) => {
  const { handleSubmit } = useFormContext<UpdateUserFormValues>();

  return (
    <SC.Root onSubmit={onSubmit && handleSubmit(onSubmit)}>
      <SC.InputContainer>
        {requirePasswordChange ? (
          <BaseText kind='Body_13_Regular'>
            초기 비밀번호로 로그인하셨습니다. 계속 이용하려면 비밀번호를 변경해 주세요.
          </BaseText>
        ) : (
          <>
            <Email />
            <Name />
            <Tel />
            <MfaMethod />
          </>
        )}
        <Password />
        <Divider direction='horizontal' css={mv(8)} />
        {!requirePasswordChange && <IsChangePassword />}
        <NewPassword />
        <ConfirmNewPassword />
      </SC.InputContainer>
      <Divider direction='horizontal' />
      <Flex css={padding('16px 24px')} alignment='center' justify='flex-end' gap={8}>
        <Button size='xsmall' kind='outlined_secondary' loading={loading} disabled={disabled} onClick={onCancel}>
          {requirePasswordChange ? '로그아웃' : '닫기'}
        </Button>
        <Button type='submit' size='xsmall' kind='primary' loading={loading} disabled={disabled}>
          {requirePasswordChange ? '비밀번호 변경' : '수정'}
        </Button>
      </Flex>
    </SC.Root>
  );
};

const SC = {
  Root: styled.form`
    ${flex({ direction: 'column' })}
    position: relative;
  `,
  InputContainer: styled.div`
    ${flex({ direction: 'column', gap: 8 })}
    padding: 16px 24px;
  `,
};
